import React from "react";
import { getOutgoingConnections } from "../../utils/workflowGraph";

export default function TransitionButtons({
  workflow,
  currentStageId,
  history,
  taskValid,
  onTransition,
}) {
  const outs = getOutgoingConnections(workflow, currentStageId);
  const visitedTargets = new Set(history.map((h) => h.stageId).filter(Boolean));

  if (!outs.length) {
    return (
      <button
        className="btn-primary btn-complete"
        disabled={!taskValid}
        onClick={() => onTransition(null)}
      >
        Complete Workflow ✓
      </button>
    );
  }

  return (
    <div className="transition-buttons">
      {outs.map((c) => {
        const target = workflow.stages.find((s) => s.id === c.targetStageId);
        if (!target) return null;
        const label = c.label || target.name;
        const isRework = visitedTargets.has(target.id);
        return (
          <button
            key={c.id}
            className={`btn-transition ${isRework ? "rework" : "forward"}`}
            disabled={!taskValid}
            onClick={() => onTransition(c)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
